import { React, useState, useEffect } from 'react';
import style from './../adminSect.module.scss';
import CustomSideModal from './Modal';
import { CustomPaginate, LoadingTable } from './../../utils/Utils';
import { RightOutlined } from '@ant-design/icons';

const Table = (props) => {
  const {
    usersTable,
    tablePadding,
    sellsTBody,
    id,
    loadingComp,
    usersTableContainer,
  } = style;
  const {
    toggleModal,
    visits,
    setPage,
    page,
    totalPages,
    status,
    setNoVisitsFound,
    noVisitsFound,
    totalVisits
  } = props;
  const [showSideBar, setShowSideBar] = useState(false);
  const [visitData, setVisitData] = useState({});

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (visits.length === 0 && !status) {
      // if req are pending
      setNoVisitsFound(false);
      setIsLoading(true);
    } else if (visits.length === 0) {
      // if the req is here but empty
      setNoVisitsFound(true);
      setIsLoading(false);
    } else {
      setNoVisitsFound(false);
      setIsLoading(false);
    }
  }, [visits, status]);

  const modalTrigger = (s, dataState, set, state) => {
    dataState(s);
    toggleModal(set, state);
  };

  return (
    <div className={`${usersTableContainer} visits_table`}>
      <div className={tablePadding}>
        <table className={usersTable}>
          <thead>
            <tr>
              <th>
                <b>Stand</b>
              </th>
              <th>
                <b>N° stand</b>
              </th>
              <th>
                <b>Hall stand</b>
              </th>
              <th>
                <b>Visitador</b>
              </th>
              <th>
                <b>Fecha/Hora</b>
              </th>
              <th>
                <b>Visitas: {totalVisits}</b>
              </th>
            </tr>
          </thead>
          <tbody className={sellsTBody}>
            {visits
              ? visits.map((visit, i) => {
                return (
                  <tr
                    key={i}
                    onClick={() =>
                      modalTrigger(visit, setVisitData, setShowSideBar, false)
                    }
                  >
                    <td className={id}>{visit.stand?.name}</td>
                    <td className={id}>{visit.stand?.standNumber}</td>
                    <td className={id}>{visit.stand?.section}</td>
                    <td className={id}>{visit.user?.pharmacy?.name || visit.user?.pharmacy?.accountNumber || visit.user?.accountNumber || visit.user?.fullName}</td>
                    <td className={id}>{visit.createdAt}</td>
                    <td>
                      <RightOutlined />
                    </td>
                  </tr>
                );
              })
              : ''}
          </tbody>
        </table>
        {isLoading && (
          <div className={loadingComp}>
            <LoadingTable />
          </div>
        )}
        {noVisitsFound && (
          <div className={loadingComp}>No se encontraron visitas</div>
        )}
      </div>

      <CustomPaginate setPage={setPage} page={page} totalPages={totalPages} />

      {showSideBar && (
        <CustomSideModal
          setShowSideBar={setShowSideBar}
          showSideBar={showSideBar}
          visitData={visitData}
        />
      )}
    </div>
  );
};

export default Table;
